"use strict";

module.exports = function getGroups(str) {
  return str.split(/[:\s+]/);
};


//////////////////
// WEBPACK FOOTER
// ./~/time-input/dist/lib/get-groups.js
// module id = 935
// module chunks = 0